import { Component } from '@angular/core';

@Component({
  selector: 'app-pfs-view-grid',
  templateUrl: './pfs-view-grid.component.html',
  styleUrls: ['./pfs-view-grid.component.css']
})
export class PfsViewGridComponent {

}
